// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-btn[data-v-7b8da795]{max-width:50%!important}.bx--btn-set[data-v-7b8da795]{height:100%}.wizard-checkbox[data-v-7b8da795]{margin-left:16px}.error-notification[data-v-7b8da795]{position:absolute!important;right:0;top:0;height:unset}", ""]);
// Exports
module.exports = exports;
